// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.radio-label {
    margin-right: 15px;
}

.email-Input {
    margin-right: 1em;
    width: 17em;
}

.email-Input-searchBtn {
    margin-right: 15px;
    display: inline-block;
}

.container2 {
    background-color: #F1F1F1;
    border: solid 1px #d4d4d4;
    border-radius: 5px;
    margin-bottom: 15px;
    padding: 50px;
}

.search-button {
    background-color: #286090;
    color: white;
    padding: 3px 15px;
    border-radius: 5px;
    cursor: pointer;
    margin-left: 10px;
}

.addBtn {
    margin-top: 15px;
}

.button-group {
    display: flex;
    justify-content: center;
    gap: 30px;
}

.row.grayBackground {
    margin-top: 15px;
    background-color: #F1F1F1;
    margin-bottom: 15px;
}

.center-content {
    margin: auto !important;
    text-align: center;
}

.form-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.form-group {
    flex: 1;
    margin-right: 20px;
}

.upload-input-file {
    margin: 10px 15px;
    font-size: 12px;
    font-family: Roboto, sans-serif;
    background-color: #286090;
    padding: 10px;
    color: white;
    border-radius: 5px;
    border: none;
    cursor: pointer;
}

.upload-container {
    flex: 2;
    display: flex;
    align-items: center;
}

.upload-container label {
    margin-right: 10px;
}

.upload-container input {
    margin-right: 10px;
}

strong {
    font-family: "GothamBold", Arial, sans-serif !important;
    font-weight: normal !important;
}

.content {
    font-family: "GothamNarrowBook", Arial, sans-serif;
}

.file-container {
    border: 2px solid #0B2D71;
    width: 100%;
    margin: 20px auto;
    border-radius: 10px;
    background-color: #fff;
}

.select-text {
    color: white;
    padding: 5px;
    background-color: #0B2D71;
    text-align: left;
    border-radius: 5px 5px 0 0;
    font-family: "GothamBold", Arial, sans-serif;
}

.text-padding {
    padding-left: 2%;
    padding-right: 2%;
    padding-bottom: 1%;
}

#closeSuccessModal {
    background-color: #007bff;
    color: white;
    border: none;
    padding: 5px 10px;
    text-align: right;
    text-decoration: none;
    display: inline-block;
    font-size: 14px;
    margin: 10px 0;
    cursor: pointer;
    border-radius: 4px;
    position: absolute;
    right: 20px;
    bottom: 20px;
}

#closeSuccessModal:hover {
    background-color: #0056b3;
}

.modal {
    display: none;
    position: fixed;
    z-index: 1;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: transparent;
}

.modal-content {
    background-color: #fefefe;
    margin: auto;
    padding: 20px;
    border: 1px solid #888;
    width: 80%;
    max-width: 35%;
    height: auto;
    max-height: 300px;
    overflow-y: auto;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

mat-spinner {
    margin: auto;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.b {
    float: left;
    padding-left: 400px;

}`, "",{"version":3,"sources":["webpack://./src/app/doa/temporary-doa/temporary-doa.component.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,OAAO;IACP,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,+BAA+B;IAC/B,yBAAyB;IACzB,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,OAAO;IACP,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,uDAAuD;IACvD,8BAA8B;AAClC;;AAEA;IACI,kDAAkD;AACtD;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,gBAAgB;IAChB,0BAA0B;IAC1B,4CAA4C;AAChD;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;IACjB,qBAAqB;IACrB,qBAAqB;IACrB,eAAe;IACf,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,eAAe;IACf,UAAU;IACV,SAAS;IACT,QAAQ;IACR,gCAAgC;IAChC,WAAW;IACX,YAAY;IACZ,cAAc;IACd,6BAA6B;AACjC;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,UAAU;IACV,cAAc;IACd,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,4EAA4E;AAChF;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,mBAAmB;;AAEvB","sourcesContent":[".radio-label {\n    margin-right: 15px;\n}\n\n.email-Input {\n    margin-right: 1em;\n    width: 17em;\n}\n\n.email-Input-searchBtn {\n    margin-right: 15px;\n    display: inline-block;\n}\n\n.container2 {\n    background-color: #F1F1F1;\n    border: solid 1px #d4d4d4;\n    border-radius: 5px;\n    margin-bottom: 15px;\n    padding: 50px;\n}\n\n.search-button {\n    background-color: #286090;\n    color: white;\n    padding: 3px 15px;\n    border-radius: 5px;\n    cursor: pointer;\n    margin-left: 10px;\n}\n\n.addBtn {\n    margin-top: 15px;\n}\n\n.button-group {\n    display: flex;\n    justify-content: center;\n    gap: 30px;\n}\n\n.row.grayBackground {\n    margin-top: 15px;\n    background-color: #F1F1F1;\n    margin-bottom: 15px;\n}\n\n.center-content {\n    margin: auto !important;\n    text-align: center;\n}\n\n.form-row {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.form-group {\n    flex: 1;\n    margin-right: 20px;\n}\n\n.upload-input-file {\n    margin: 10px 15px;\n    font-size: 12px;\n    font-family: Roboto, sans-serif;\n    background-color: #286090;\n    padding: 10px;\n    color: white;\n    border-radius: 5px;\n    border: none;\n    cursor: pointer;\n}\n\n.upload-container {\n    flex: 2;\n    display: flex;\n    align-items: center;\n}\n\n.upload-container label {\n    margin-right: 10px;\n}\n\n.upload-container input {\n    margin-right: 10px;\n}\n\nstrong {\n    font-family: \"GothamBold\", Arial, sans-serif !important;\n    font-weight: normal !important;\n}\n\n.content {\n    font-family: \"GothamNarrowBook\", Arial, sans-serif;\n}\n\n.file-container {\n    border: 2px solid #0B2D71;\n    width: 100%;\n    margin: 20px auto;\n    border-radius: 10px;\n    background-color: #fff;\n}\n\n.select-text {\n    color: white;\n    padding: 5px;\n    background-color: #0B2D71;\n    text-align: left;\n    border-radius: 5px 5px 0 0;\n    font-family: \"GothamBold\", Arial, sans-serif;\n}\n\n.text-padding {\n    padding-left: 2%;\n    padding-right: 2%;\n    padding-bottom: 1%;\n}\n\n#closeSuccessModal {\n    background-color: #007bff;\n    color: white;\n    border: none;\n    padding: 5px 10px;\n    text-align: right;\n    text-decoration: none;\n    display: inline-block;\n    font-size: 14px;\n    margin: 10px 0;\n    cursor: pointer;\n    border-radius: 4px;\n    position: absolute;\n    right: 20px;\n    bottom: 20px;\n}\n\n#closeSuccessModal:hover {\n    background-color: #0056b3;\n}\n\n.modal {\n    display: none;\n    position: fixed;\n    z-index: 1;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n    width: 100%;\n    height: 100%;\n    overflow: auto;\n    background-color: transparent;\n}\n\n.modal-content {\n    background-color: #fefefe;\n    margin: auto;\n    padding: 20px;\n    border: 1px solid #888;\n    width: 80%;\n    max-width: 35%;\n    height: auto;\n    max-height: 300px;\n    overflow-y: auto;\n    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n}\n\nmat-spinner {\n    margin: auto;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n}\n\n.b {\n    float: left;\n    padding-left: 400px;\n\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
